'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var mastercard = require('@medipass/assets/images/mastercard.svg');
var visa = require('@medipass/assets/images/visa.svg');
var components_BriefDetailBox = require('../../components/BriefDetailBox.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mastercard__default = /*#__PURE__*/_interopDefaultLegacy(mastercard);
var visa__default = /*#__PURE__*/_interopDefaultLegacy(visa);

var _excluded = ["addonComponent", "children", "lastFour", "type", "isExpired", "isSelected"];

var _templateObject, _templateObject2;
var Box = bumbag.styled(components_BriefDetailBox["default"])(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  justify-content: space-between;\n"])));
var Content = bumbag.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n  display: flex;\n  align-items: center;\n"])));

var CardDetailsBox = function CardDetailsBox(_ref) {
  var addonComponent = _ref.addonComponent,
      children = _ref.children,
      lastFour = _ref.lastFour,
      type = _ref.type,
      isExpired = _ref.isExpired;
      _ref.isSelected;
      var props = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(Box, props, /*#__PURE__*/React__default["default"].createElement(Content, null, type === 'Visa' && /*#__PURE__*/React__default["default"].createElement("img", {
    src: visa__default["default"],
    alt: "visa"
  }), type === 'MasterCard' && /*#__PURE__*/React__default["default"].createElement("img", {
    src: mastercard__default["default"],
    alt: "mastercard"
  }), /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    className: "has-text-weight-semibold margin-left-10"
  }, children ? children({
    type: type,
    lastFour: lastFour
  }) : "**** **** **** " + lastFour + " " + (isExpired ? 'EXPIRED' : ''))), addonComponent);
};

CardDetailsBox.defaultProps = {
  addonComponent: null,
  children: null,
  className: '',
  onClick: null,
  isExpired: false
};

exports["default"] = CardDetailsBox;
